module.exports = __webpack_public_path__ + "static/media/MountainPeakFlashbackA0017_design_clean_v002.36883300.webp";